import HrGeneralLeave from "app/models/hrGeneralLeave"
import HrUnavailability from "app/models/hrUnavailability"
import User from "app/models/user"
import { Params as UserParams } from "app/redux/users/users.reducer"
import { Action, Types } from "./absencesTable.actions"

export type UserMonth = {
  user: User
  absences: Absence[]
}

export type Absence = {
  date: string
  hrUnavailabilities: HrUnavailability[]
  hrGeneralLeaves: HrGeneralLeave[]
  selected: boolean
}

export type AbsencesTableState = {
  date: { month: number; year: number } | undefined
  params: { from: string; to: string }
  userParams: UserParams
  clickedRow: string | undefined
  data: UserMonth[]
  loading: boolean
  errors: object
}

const initialState: AbsencesTableState = {
  date: undefined,
  params: { from: "", to: "" },
  userParams: {},
  clickedRow: undefined,
  data: [],
  loading: false,
  errors: {},
}

export default (state = initialState, action: Action): AbsencesTableState => {
  switch (action.type) {
    case Types.SELECT:
      return {
        ...state,
        data: state.data.map((row: UserMonth) => {
          if (row.user.id === action.payload.userId) {
            const absences = row.absences.map((absence: Absence) => {
              if (absence.date === action.payload.date) {
                return {
                  ...absence,
                  selected: action.payload.selected,
                }
              }
              return absence
            })
            return {
              ...row,
              absences,
            }
          }
          return row
        }),
      }

    case Types.RESET:
      return {
        ...state,
        clickedRow: undefined,
        data: state.data.map((row: UserMonth) => {
          const absences = row.absences.map((absence: Absence) => {
            if (absence.selected) {
              return {
                ...absence,
                selected: false,
              }
            }
            return absence
          })
          return {
            ...row,
            absences,
          }
        }),
      }

    case Types.GET:
      return {
        ...state,
        params: action.payload.params,
        userParams: action.payload.userParams,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        date: action.payload.date,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.SET_CLICKED_ROW:
      return {
        ...state,
        clickedRow: action.payload.userId,
      }

    default:
      return state
  }
}
